enum ManualWorkerStatus {
  Enqueued = "enqueued",
  Executing = "executing",
  Failed = "failed",
  Succeeded = "succeeded",
}

export { ManualWorkerStatus };
